import { useEffect, useState } from 'react'
import { Attribution as SharedAttribution } from '@giphy/react-giphy-brand'
import { sample } from 'lodash'
import styled, { css } from 'styled-components'

const BackgroundContainer = styled.div<{ blur: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    transition: opacity 0.6s linear;

    ${(props) =>
        props.blur &&
        css`
            filter: brightness(80%) blur(100px);
        `}
`

const Attribution = styled(SharedAttribution)`
    span {
        transition: color 0.25s ease;

        &:hover {
            color: white;
        }
    }
`

const Video = styled.video`
    height: 100%;
    width: 100%;
    object-fit: cover;
`

const FooterContainer = styled.div<{ hasSeenToSMessage }>`
    position: absolute;
    padding-left: ${(props) => (props.hasSeenToSMessage ? 15 : 43)}px;
    padding-right: ${(props) => (props.hasSeenToSMessage ? 15 : 43)}px;
    bottom: ${(props) => (props.hasSeenToSMessage ? 15 : 43)}px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    transition: bottom 0.5s cubic-bezier(0.77, 0, 0.175, 1);
`

export interface BackgroundProps {
    webmUrl?: string
    mp4Url?: string
    name?: string
    profileUrl?: string
    avatarUrl?: string
    blur?: boolean
    withAttribution?: boolean
}

interface BackgroundComponentProps extends BackgroundProps {
    local?: any
    autoFillBgProps?: boolean
}

export const loadBackgroundData = async (): Promise<BackgroundProps> => {
    const result = await fetch(`/ajax/animated-backgrounds/`)
    const json = await result.json()
    const {
        webm_url: webmUrl,
        mp4_url: mp4Url,
        artist: { avatar_url: avatarUrl, profile_url: profileUrl, name },
    } = sample(json.result)

    return {
        webmUrl,
        mp4Url,
        profileUrl,
        avatarUrl,
        name,
    }
}

const Background = (props: BackgroundComponentProps) => {
    const { withAttribution = true, local, autoFillBgProps = true } = props
    const [backgroundProps, setBackgroundProps] = useState<BackgroundProps>()
    const loadBackground = async () => {
        const { webmUrl, mp4Url, profileUrl, avatarUrl, name } = await loadBackgroundData()

        setBackgroundProps({
            webmUrl,
            mp4Url,
            profileUrl,
            avatarUrl,
            name,
        })
    }
    useEffect(() => {
        if (autoFillBgProps) {
            loadBackground()
        }
    }, [])
    const {
        webmUrl,
        mp4Url,
        name,
        profileUrl,
        avatarUrl,
        blur = false,
    } = autoFillBgProps ? backgroundProps || {} : props

    return webmUrl ? (
        <>
            <BackgroundContainer blur={blur}>
                <Video preload="auto" autoPlay loop muted>
                    <source src={mp4Url} type="video/mp4" />
                    <source src={webmUrl} type="video/webm" />
                </Video>
            </BackgroundContainer>
            {withAttribution && (
                <FooterContainer hasSeenToSMessage={local?.hasSeenToSMessage}>
                    <Attribution
                        user={{
                            avatar_url: avatarUrl,
                            username: name,
                            profile_url: profileUrl,
                            is_verified: true,
                        }}
                    />
                </FooterContainer>
            )}
        </>
    ) : null
}

export default Background
